// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--nf9C_{0%{background-position:200% 0}100%{background-position:-200% 0}}@media all and (min-width: 768px){.logo-header{font-size:2.2rem !important}}@media all and (max-width: 768px){.logo-header{font-size:1.3rem !important}}.logos-container-wrapper--nhp6j{overflow:hidden;margin-left:-50px;width:calc(100% + 100px)}.logos-container--GzKGY{white-space:nowrap;width:-moz-fit-content;width:fit-content;will-change:transform}.business-logos--jHl0L{flex-shrink:0;max-width:215px;max-height:45px;padding:.2rem;-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logos-container-wrapper": "logos-container-wrapper--nhp6j",
	"logos-container": "logos-container--GzKGY",
	"business-logos": "business-logos--jHl0L",
	"shimmer-loading": "shimmer-loading--nf9C_"
};
export default ___CSS_LOADER_EXPORT___;
